import type { WSModel } from "@/services/socket/ws.service";
import { WSCommands } from "@/constants/ws";
import { useTripStore } from "@/store/trip.store";

export class TripViewHandler implements WSModel {
  private store = useTripStore();

  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    switch (data.command) {
      case WSCommands.trip:
        this.handleTrip(data);
        break;
      case WSCommands.tripTruck:
        this.handleTripTruck(data);
    }
  }

  private handleTripTruck(data: any) {
    if (data?.truck) {
      this.store.setTripTruck(data.truck);
    }
  }

  private handleTrip(data: any) {
    if (data?.tripId) {
      this.store.setTripId(data.tripId);
    }
  }
}
